import { SphereTooltip } from "@components/common/sphere-tooltip";
import { BaseSnapshotProps } from "@custom-types/base-types";
import { Stack } from "@mui/material";
import { ShareLinkIcon } from "@src/flat-ui/flat-ui-all";
import { SHOW_ON_HOVER_CLASS } from "@utils/ui-utils";
import { SnapshotOptionsMenu } from "@pages/project-details/project-snapshots/snapshot-options-menu";
import { SphereActionDivider } from "@components/common/sphere-action-divider";
import { IconButton } from "@flat-ui";
import { SnapshotShareDialog } from "@pages/project-details/project-snapshots/snapshot-share-dialog";
import { useState } from "react";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { SnapshotEvents } from "@utils/track-event/track-event-list";

/** Renders the options for a snapshot, including sharing and 3-dot menu */
export function SnapshotOptions({ snapshot }: BaseSnapshotProps): JSX.Element {
  const { trackEvent } = useTrackEvent();

  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
        justifyContent: "right",
        // This will be overridden by parent component using SHOW_ON_HOVER_CLASS
        visibility: "hidden",
      }}
      className={SHOW_ON_HOVER_CLASS}
    >
      <SnapshotShareDialog
        snapshot={snapshot}
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        location="snapshot-action"
      >
        <SphereTooltip title="Share snapshot">
          <IconButton
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              e.preventDefault();

              trackEvent({
                name: SnapshotEvents.openShareSnapshot,
                props: {
                  snapshotId: snapshot.id,
                  accessLevel: snapshot.accessLevel,
                  location: "snapshot-table-row",
                },
              });

              setIsDialogOpen(true);
            }}
            size="s"
          >
            <ShareLinkIcon />
          </IconButton>
        </SphereTooltip>
      </SnapshotShareDialog>

      <SphereActionDivider />

      <SnapshotOptionsMenu snapshot={snapshot} />
    </Stack>
  );
}
